import{ useEffect, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useLocation, useNavigate } from "react-router-dom";

import { RiPencilFill } from "react-icons/ri";
import SurveyQuestionsAddAndEditModal from "./modals/SurveyQuestionsModal";
import { useSurveyQuestionList } from "./hook/useSurvey";
import { COLORS } from "../../constants/colors";
 
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { showToast } from "../../utils/toastUtils";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";

const SurveyQuestionColumns = (
  handleEditSurveyQuestion: (row: any) => void
) => [
  {
    name: "Survey Question Type",
    selector: (row: { survey_question_type: string }) =>
      row.survey_question_type || "-",
    sortable: true,
    width: "220px",
  },
  {
    name: "Survey Question Option",
    selector: (row: { survey_question_options: string }) =>
      row.survey_question_options || "-",
    sortable: true,
    width: "250px",
  },
  {
    name: "Survey Question",
    selector: (row: { survey_question: string }) => row.survey_question || "-",
    sortable: true,
    wrap: true,
    width: "200px",
  },
  {
    name: "Survey",
    selector: (row: { survey: string }) => row.survey || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Status",
    selector: (row: { status: string }) => row.status || "-",
    sortable: true,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center">
        <button
          onClick={() => handleEditSurveyQuestion(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
        >
          <RiPencilFill style={{ fill: "#fff" }} /> Edit
        </button>
      </div>
    ),
  },
];

const SurveyQuestions = () => {
  const navigate = useNavigate();
  const { startPolling, stopPolling } = useExcelPolling();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
  const location = useLocation();
  const SureveyData = location.state;
  const { SurveyId } = location.state;

  // console.log(
  //   "🚀 ~ SurveyQuestions.tsx:68 ~ SurveyQuestions ~ SureveyData:",
  //   SureveyData?.SurveyId
  // );

  // const [SurveyID,setSurveyId] = useState<number | null>(null);
  const [SurveyID, setSurveyId] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  // const [SurveyID,setSurveyId] = useState<number>(SureveyData?.SurveyId)
  const [SurveyRowQuestion, setSurveyRowQuestion] = useState();

  useEffect(() => {
    if (SureveyData?.SurveyId) {
      setSurveyId(SureveyData.SurveyId);
      setRefreshKey((prev) => prev + 1);
    } else {
      setSurveyId(SurveyId);
      setRefreshKey((prev) => prev + 1);
    }
  }, [SureveyData, SurveyId]);

  const [filterData, setfilterData] = useState({
    page: 1,
    limit: 10,
    search: "",
  });
  // const {data,isLoading,isSuccess } = useSurveyQuestionList({enable:true   ,params:{
  //  page:filterData.page,
  //  limit:filterData.limit,
  //  search:filterData.search
  // },SurveyID: SureveyData.SurveyId})

  const { data, isLoading, isSuccess } = useSurveyQuestionList({
    retry: !!SureveyData?.SurveyId || !!SurveyId,
    enable: true,
    params: filterData,
    SurveyID: SurveyId ? SurveyId : SureveyData?.SurveyId,
    refreshKey, // 👈 PASS refreshKey
  });

  // console.log('data-------->',data?.rowData);

  const handleEditSurveyQuestion = (row: any) => {
    setCheckAddEditStatus("Edit");
    // console.log('row-Data-------->',row);
    setSurveyRowQuestion(row);
    setIsModalOpen(true);
  };
  const toggleModal = () => {
    setCheckAddEditStatus("Add");
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setfilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (newPerPage: any, page: any) => {
    setfilterData((prev: any) => ({
      ...prev,
      limit: newPerPage,
      page: page,
    }));
  };

  const handleSearch = (val: any) => {
    setfilterData((prev: any) => ({
      ...prev,
      search: val,
    }));
  };

  const downloadExcelGet = async () => {
    const param: Record<string, any> = {
      ...(filterData.search == "" ? {} : { search: filterData.search }),
    };

    const queryString = new URLSearchParams(param).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.SURVEY.GET_EXCEL_DOWNLOAD_SURVEY_QUESTION}/${SurveyId}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "onFailed in survey Question ");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "onExpire in survey Question");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "onDelete in survey Question");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div className="container mt-3">
      <PageHeader
        title="Survey Question"
        buttons={[
          {
            label: "+ Add Question",
            onClick: toggleModal,
            color: COLORS.primary,
          },
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        paginationTotalRows={data?.rowData.pagination?.total_records || 0}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Survey Question"
        columns={SurveyQuestionColumns(handleEditSurveyQuestion)}
        data={(!isLoading && isSuccess && data?.formatedData) || []}
      />
      <SurveyQuestionsAddAndEditModal
        SurveyRowQuestion={SurveyRowQuestion}
        SurveyID={SurveyID}
        setCheckAddEditStatus={setCheckAddEditStatus}
        checkAddEditStatus={checkAddEditStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        title={
          checkAddEditStatus == "Add"
            ? "Add Survey Question"
            : "Edit Survey Question"
        }
      />
    </div>
  );
};

export default SurveyQuestions;
